import common from './common.json';
import translations from './translations.json';
import features from './features.json';
import candidates from './candidates.json';
import employerHome from './employerHome.json';

export default {
  common,
  translations,
  features,
  candidates,
  employerHome
};
